<template>
  <div id="tab-hawb" class="app-main-inner">
    <div style="display: flex">
      <div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="billFinalRowData"
          :auto-fit-content="false"
          style="height: 500px;width: 200px;"
          @gridReady="params=>{gridApi=params.api}"
        />
        <div style="display: flex;justify-content: space-between;margin-top: 10px;">
          <el-button no="1" type="primary" style="flex-grow: 1" :disabled="!isEdit" @click="addSubBill">{{ $t("CargoMsg.Cargo_Add") }}</el-button>
          <el-button no="2" type="danger" style="flex-grow: 1" :disabled="!isEdit" @click="removeSubBill">{{ $t("CargoMsg.Cargo_Delete") }}</el-button>
        </div>
      </div>
      <common-hawb ref="hawb" :job="job" :form="form" :action="action" :context="context" view-source="AeTabSubBill" />
    </div>
  </div>
</template>

<script>
import CommonHawb from './components/CommonHAWB'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { TabError } from '@/utils/class/TabError'
import cargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabSubBill',
  components: {
    CommonHawb, cargoAgGrid
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      job: {},
      form: new AirCargoDoc().fillDefaultValue().getData(),
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
          this.isSelected = false
        },
        onRowClicked: event => { this.curBill = event.data; this.onSelectionChange(event.data) }
      },
      gridParams: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BlSplitList'),
          field: 'hblNbr2',
          suppressMenu: true,
          width: 190
        }
      ],
      rowData: [],
      gridApi: null,
      isSelected: false,
      curBill: null
    }
  },
  computed: {
    billFinalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    }
  },
  watch: {

  },
  async created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.rowData = []
      this.job = row
      const cargoDocs = await new AirExportJob(this.job).getAirCargoDoc()
      if (cargoDocs && cargoDocs.length > 0) {
        for (const doc of cargoDocs) {
          if (doc.docType === CargoDocConsts.HAWB2) {
            this.rowData.push(doc)
          }
        }
      }
      this.$nextTick(async() => {
        await ensureExecuteSuccess(() => this.gridApi)
        let selectedNode = null
        const { rowsToDisplay } = this.gridApi.getModel()
        if (rowsToDisplay && rowsToDisplay.length > 0) {
          if (this.curBill) {
            selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curBill.hblNbr2) || rowsToDisplay[0]
          } else {
            selectedNode = rowsToDisplay[0]
          }
          const selectedData = selectedNode ? selectedNode.data : this.rowData[0]
          selectedNode.setSelected(true)
          if (selectedData.uuid) {
            await new AirCargoDoc(selectedData).getOtherCharge()
          }
          await this.onSelectionChange(selectedData)
        } else {
          this.form = new AirCargoDoc().fillDefaultValue().getData()
        }
      })
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        params.DOC_UUID = this.form.uuid
        params.cargoDocUuid = this.form.uuid
        params.category = 'AEHAWB2'
        params.ctx = new AirCargoDoc(this.form)
      }
      return params
    },
    async getSubmitData() {
      if (!this.rowData || this.rowData.length === 0) return {}
      this.validateForm()
      const doc = []
      for (const c of this.rowData) {
        const d = {}
        const docKey = new AirCargoDoc().fillDefaultValue().getData()
        Object.keys(docKey).forEach((key) => {
          if (c[key]) {
            d[key] = c[key]
          }
        })
        d.deleted = c.deleted
        doc.push(d)
      }
      return {
        airCargoDoc: doc,
        job: { ...this.job }
      }
    },
    async addSubBill() {
      let needDocType
      if (this.job.masterFlag) {
        needDocType = 'MAWB'
      } else if (this.job.operateType === AirExportConstants.CONSOLE.code) {
        needDocType = 'HAWB'
      } else if (this.job.operateType === AirExportConstants.DIRECT.code) {
        needDocType = 'MAWB'
      } else if (this.job.operateType === AirExportConstants.BACK_TO_BACK.code) {
        needDocType = 'HAWB'
      }
      // 优先获取job中数据 ，不行在自行创建
      let doc
      if (this.job.airCargoDoc) {
        for (const cDoc of this.job.airCargoDoc) {
          if (cDoc.docType === needDocType) {
            doc = cDoc
          }
        }
      }
      // 补充默认值
      if (!doc.kglb) {
        doc.kglb = 'K'
      }
      if (!doc.wtVal) {
        doc.wtVal = 'PP'
      }
      if (!doc.other) {
        doc.other = 'PP'
      }
      if (!this.job.airCargoDoc || !doc) {
        const mawb = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, false)
        const hawb = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, false)
        if (this.job.masterFlag) {
          doc = mawb
        } else if (this.job.operateType === AirExportConstants.CONSOLE.code) {
          doc = hawb
        } else if (this.job.operateType === AirExportConstants.DIRECT.code) {
          doc = mawb
        } else {
          doc = hawb == null ? mawb : hawb
        }
      }
      let newDoc
      if (!doc) {
        newDoc = new AirExportJob(this.job).getCargoDoc(CargoDocConsts.HAWB2, true)
      } else {
        newDoc = new AirCargoDoc().fillDefaultValue()
        newDoc.copyBasic(doc)
        newDoc.kglb = doc.kglb
        newDoc.docType = CargoDocConsts.HAWB2
      }
      const entityDefValUtil = new EntityDefaultValueUtil(this.$store.getters.currentOfficeId, this)
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      if (entityDefValUtil.cargoDoc) {
        for (let i = 1; i < 8; i++) {
          newDoc['notifyLine' + i] = entityDefValUtil.cargoDoc['aeFhawbNotifyLine' + i]
        }
      }
      if (cache.config.get('ToExoSystem') === 'JYD') {
        newDoc.notifyCode = ''
        newDoc.notifyId = ''
        newDoc.notifyLine1 = 'SAME AS CONSIGNEE'
        newDoc.notifyLine2 = ''
        newDoc.notifyLine3 = ''
        newDoc.notifyLine4 = ''
        newDoc.notifyLine5 = ''
        newDoc.notifyLine6 = ''
        newDoc.notifyLine7 = ''
      }
      newDoc.jobUuid = this.job.uuid
      newDoc.hblNbr2 = this.job.hawb
      await this.$refs.hawb.pm.getFreightTermFunc(this.job)
      this.rowData.push(newDoc)
      this.form = newDoc
      this.curBill = newDoc
      setTimeout(() => {
        this.setSelectNode(this.rowData.length - 1)
      }, 0)
    },
    removeSubBill() {
      const selectedRows = this.gridApi.getSelectedRows()
      const row = selectedRows.length ? selectedRows[0] : null
      if (!row) {
        return
      }
      if (row.uuid) {
        row.deleted = true
        const tempRowData = this.rowData
        this.rowData = []
        this.$nextTick(() => {
          this.rowData = tempRowData
          setTimeout(() => {
            this.setSelectNode(0)
          }, 100)
        })
      } else {
        const index = this.rowData.findIndex(p => p === row)
        if (index > -1) {
          this.rowData.splice(index, 1)
          setTimeout(() => {
            this.setSelectNode(0)
          }, 100)
        }
      }
    },
    validateForm() {
      const cargoDoc = this.form
      if (cargoDoc && !cargoDoc.hblNbr2) {
        throw new TabError(this.$t('queryJob.PleaseEnterTheSplitNumber'), 'tabSubBill')
      }
      return true
      // let readyIn = false
      // for (const doc of this.rowData) {
      //   if (doc !== cargoDoc && doc.hblNbr2 === cargoDoc.hblNbr2) {
      //     readyIn = true
      //     break
      //   }
      // }
      // if (readyIn) {
      //   this.$message.warning(this.$t('Payment.separateNumber') + cargoDoc.hblNbr2 + this.$t('queryJob.AlreadyExists'))
      // }
      // return !readyIn
    },
    onSelectionChange(data) {
      if (!data) {
        return
      }
      this.form = data
      this.curBill = this.form
    },
    setSelectNode(index) {
      const selectedNode = this.gridApi.getModel().rowsToDisplay[index]
      selectedNode.setSelected(true)
    },
    executeTask() {
      this.$refs.hawb.executeTask()
    }
  }
}
</script>

<style lang="scss">
  #app #tab-hawb {
    .el-form-item__content {
      width: 255px !important;
    }
    .label-none {
      .el-form-item__content {
        width: 490px !important;
      }
    }
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #8cc8ff;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>
